<template>
  <div>

    <h1>Hello {{firstname}}</h1>
    <p>You have successfully signed in with Cognito User Pools.</p>

    <h2>Profile</h2>
    <p></p>
    <div class="code">
      <pre>{{profile}}</pre>
    </div>

    <h2>Access Token</h2>
    <div class="code">
      <pre>{{accessToken}}</pre>
    </div>

    <h2>ID Token</h2>
    <div class="code">
      <pre>{{idToken}}</pre>
    </div>
  </div>
</template>

<script>
  export default {
    name: "TokenInfo",
    data: function() {
      return {};
    },
    computed: {
      accessToken() {
        return this.$store.getters.accessToken;
      },
      idToken() {
        return this.$store.state.auth.idToken;
      },
      profile() {
        return this.$store.getters.profile;
      },
      firstname() {
        return this.$store.getters.profile.name;
      }
    },
    created() {}
  };
</script>



// WEBPACK FOOTER //
// src/views/tokeninfo.vue